<template>
  <recording-position-tracker
    class="tangram-event-capture"
    :updateInterval="updateInterval"
    @elapsed="sendProgress"
  ></recording-position-tracker>
</template>

<script>
  import rootLogger from '@/utils/root-logger';
  import { MessageBusEventClient } from '@getgo/message-bus-js-sdk';
  import TangramPlayerEvent from '@/components/embedded/recording/tangram-player-event';
  import RecordingPositionTracker from '@/components/recording/recording-position-tracker';

  const logger = rootLogger.create('tangram');
  const addUserProperties = ({event, state}) => {
    const {uuid, machineId} = state.g2wEnv;
    const identity = {
      alias: [
        {
          aliasName: 'machineId',
          aliasId: `${machineId}`
        },
        {
          aliasName: 'uuid',
          aliasId: `${uuid}`
        }
      ]
    };
    if (state.g2sRecording && state.g2sRecording.registration) {
      const {registrantKey = '', userKey = ''} = state.g2sRecording.registration;
      identity.alias.push({
        aliasName: 'registrantKey',
        aliasId: `${registrantKey}`
      });
      identity.userId = userKey;
    }
    event.withPayloadProps({identity}, 'context');
  };

  const addResourceProperties = ({event, state}) => {
    const isContent = state.g2sRecording && state.g2sRecording.embeddedResource;
    if(isContent){
      const {productRefKey = '', resourceType = '', product = ''} = state.g2sRecording;
      event.withPayloadProps({
        playerResource: {
          product: product.toUpperCase(),
          resourceName: resourceType.toUpperCase(),
          resourceId: productRefKey
        }
      })
    }
  };

  const addVideoProperties = ({event, currentVideoTime, playerUrl, source = ''}) => {
    event.withPayloadProps({
      currentVideoTime,
      context: {
        playerContext: {
          playerUrl,
          parentUrl: document.referrer,
          sourceName: source.toUpperCase()
        }
      },
    });
  };

  export default {
  name: 'TangramEventCapture',
    components: {RecordingPositionTracker},

    data() {
      return {
        client: null,
        updateInterval: 5
      };
  },
  created() {
    this.client = new MessageBusEventClient(this.$store.state.g2wEnv.current.tangramBaseUrl);
    logger.log('tangram init');
  },

  computed: {
    videoPosition() {
      return this.$store.state.recording && this.$store.state.recording.position;
    },

    startPosition() {
      return this.$store.state.recording && this.$store.state.recording.startPosition;
    },

    duration() {
      return this.$store.state.recording && this.$store.state.recording.duration;
    },

    playState() {
      return this.$store.state.recording && this.$store.state.recording.playState;
    },

    contentFile() {
      return this.$store.state.recording && this.$store.state.recording.contentFile;
    },

    source() {
      return this.$store.state.recording && this.$store.state.recording.source;
    }
  },

  watch: {
    duration(newValue) {

      if (newValue ) {
        this.sendEvent(TangramPlayerEvent.EVENT_TYPES.LOADED, {});
      }
    },

    startPosition(newValue) {
      if (newValue) {
        this.sendEvent(TangramPlayerEvent.EVENT_TYPES.SEEK, {
          startPosition: `${this.videoPosition}`,
          endPosition: `${newValue}`
        });
      }
    },

    playState(newValue) {
      switch (newValue) {
        case 'pause':
          this.sendEvent(TangramPlayerEvent.EVENT_TYPES.PAUSE, {
            currentVideoTime: `${this.videoPosition}`
          });
          break;
      }
    }
  },
  methods: {
    sendProgress(event) {
      const curTime = event.elapsed - (event.elapsed % this.updateInterval);
      const currentVideoTime = `${curTime}`;
      this.logger.log('sendEvent', {currentVideoTime, elapsed: event.elapsed});
      this.sendEvent(TangramPlayerEvent.EVENT_TYPES.PROGRESS, {currentVideoTime});
    },

    sendEvent(playerEventType, payload){
      const event = new TangramPlayerEvent();

      switch (playerEventType) {
        case TangramPlayerEvent.EVENT_TYPES.PAUSE:
          event.withPayloadProps({
            oldstate: TangramPlayerEvent.PAUSE_STATES.PLAYING
          }, 'pauseMetadata');
          break;

        case TangramPlayerEvent.EVENT_TYPES.SEEK:
          event.withPayloadProps({
            startPosition: payload.startPosition,
            endPosition: payload.endPosition,
          }, 'seekMetadata');
          payload.currentVideoTime = payload.endPosition;
          break;

        case TangramPlayerEvent.EVENT_TYPES.LOADED:
          payload.currentVideoTime = '0';
          break;

        case TangramPlayerEvent.EVENT_TYPES.PROGRESS:
          break;
      }

      event.withPayloadProps({
        playerEventType,
        viewable: true,
        videoDuration: `${this.duration}`
      });
      payload.playerUrl = this.contentFile;
      addVideoProperties({event, source: this.source, ...payload});
      addUserProperties({event, state: this.$store.state});
      addResourceProperties({event, state: this.$store.state});

      this.pushEvent(event)
    },

    pushEvent(event){
      this.client.sendEvent(event.build());
      logger.log('tangram event pushed', {event});
    }
  }
}

</script>

<style scoped>

</style>
